import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
        },
        indexPageMap: {
        },
        routes: {
        },
    };

export default configuration;